import { firestore } from '~/firebase/init';
import { onSnapshot, collection, documentId, query, where, doc } from 'firebase/firestore';

import { SnapshotFn, CollectionSnapShotFn } from './type';

export function platformListener(platformId: string, onNext: SnapshotFn) {
  const ref = doc(firestore, `platforms`, platformId);

  return onSnapshot(ref, {
    next: onNext,
    error: (err) => {
      console.error('listen platform error', err);
    },
  });
}

export function platformRemotePickMealPointsListener(
  platformId: string,
  onNext: CollectionSnapShotFn,
) {
  const ref = collection(firestore, `platforms`, platformId, 'remotePickPoints');

  return onSnapshot(ref, onNext, (err) => {
    console.error('listen remote pick meal points err', err);
  });
}

export function remotePickMealPointListener(
  platformId: string,
  pointId: string,
  onNext: SnapshotFn,
) {
  const ref = doc(firestore, `platforms`, platformId, 'remotePickPoints', pointId);

  return onSnapshot(ref, {
    next: onNext,
    error: (err) => {
      console.error('listen remotePickMealPoint fail', err);
    },
  });
}

export function returnContainerPointsListener(platformId: string, onNext: CollectionSnapShotFn) {
  const ref = collection(firestore, 'platforms', platformId, 'returnContainerPoints');
  return onSnapshot(ref, {
    next: onNext,
    error: (error) => console.error('listen return container failed', error),
  });
}

export function returnContainerPointListener(
  platformId: string,
  pointId: string,
  onNext: SnapshotFn,
) {
  const ref = doc(firestore, 'platforms', platformId, 'returnContainerPoints', pointId);
  return onSnapshot(ref, {
    next: onNext,
    error: (error) => console.error('listen return container failed', error),
  });
}

export function platformCustomerListener(
  platformId: string,
  customerUid: string,
  onNext: SnapshotFn,
) {
  const ref = doc(firestore, 'platforms', platformId, 'customers', customerUid);
  return onSnapshot(ref, {
    next: onNext,
    error: (error) => {
      console.log('customer listener error', error);
    },
  });
}
